import React from "react";

import { Formik, Form } from "formik";
import { Search } from "icons";

import { Button } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";

import { NPI_VALIDATION } from "./validations";

import { INITIAL_NPI_REGISTRY_FORM_VALUES } from "../../../DataManagement/ReferenceData/NPIRegistry/constants";

const SearchNPI = ({ isNPILoading, handleSearch }) => (
  <Formik
    initialValues={INITIAL_NPI_REGISTRY_FORM_VALUES}
    validationSchema={NPI_VALIDATION}
    onSubmit={handleSearch}
  >
    <Form className="mt-4">
      <div className={`flex items-start my-4 space-x-2`}>
        <Input
          prefix={<Search />}
          size="large"
          name="npi"
          placeholder="Provider NPI"
        />
        <div className="h-full">
          <Button
            label="Search"
            size="large"
            className="h-10"
            type="submit"
            loading={isNPILoading}
          />
        </div>
      </div>
    </Form>
  </Formik>
);

export default SearchNPI;
